module.exports = __webpack_public_path__ + "static/1-04f2f7a5eed569f9b2b9aa7948c97eb9.jpg";